import { render, staticRenderFns } from "./NewRuhContainer.vue?vue&type=template&id=1343e558"
import script from "./NewRuhContainer.vue?vue&type=script&lang=ts"
export * from "./NewRuhContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports